import Chart from 'chart.js/dist/chart.js';
import Siema from 'siema/dist/siema.min.js';
import { tns } from 'tiny-slider/src/tiny-slider';
import { generateChart } from '../utils/chart';

import {
  addOnClickOnAllItems,
  recreateElement,
  toggleActiveListItems
} from '../utils/misc-utils';

document.addEventListener('DOMContentLoaded', function (e) {
  const hootsuiteHubPage = document.getElementById('hootsuite-hub');

  if (hootsuiteHubPage) {
    // Reasons
    const reasonsListItems = document.querySelectorAll(
      '.hootsuite-reasons-nav-item'
    );
    const sectionsContent = document.querySelectorAll(
      '.hootsuite-reasons-list-item'
    );

    const animateProgressBars = () => {
      const progressbarItems = document.querySelectorAll('.progress-bar');

      progressbarItems.forEach((progressBar) => {
        recreateElement(progressBar);
      });
    };

    addOnClickOnAllItems(reasonsListItems, (e) => {
      toggleActiveListItems(e.target, reasonsListItems, sectionsContent);
      animateProgressBars();
    });

    const reasonsSlider = document.querySelector('.reasons-slider');
    if (reasonsSlider) {
      if (window.screen.width < 599) {
        new Siema({
          selector: '.reasons-slider',
          perPage: 3.5,
          draggable: true,
          loop: false
        });
      }
    }

    // Outperforms section
    const outperformsListItems = document.querySelectorAll(
      '.outperforms-nav-item'
    );
    const outperformsListItemsContent = document.querySelectorAll(
      '.outperforms-item-content'
    );

    const scrollToTheCenterOfTheList = (element) => {
      // Hotfix for disabling the center scrolling for the last item
      const isTheLastItem = !element.classList.contains(
        'outperforms-item-eleven'
      );
      const isBiggerThanDesktop = window.screen.width > 1024;
      if (isTheLastItem && isBiggerThanDesktop) {
        element.scrollIntoView({ block: 'center' });
      }
    };

    addOnClickOnAllItems(outperformsListItems, (e) => {
      scrollToTheCenterOfTheList(e.target);
      toggleActiveListItems(
        e.target,
        outperformsListItems,
        outperformsListItemsContent
      );
    });

    // Outperforms section - Desktop slider
    const outperformsArrowUp = document.querySelector('.outperforms-slider-up');
    const outperformsArrowDown = document.querySelector(
      '.outperforms-slider-down'
    );
    const outperformsArrowPrev = document.querySelector(
      '.outperforms-slider-prev'
    );
    const outperformsArrowNext = document.querySelector(
      '.outperforms-slider-next'
    );

    const getActiveElementIndex = (item) =>
      [...item.parentElement.children].indexOf(item);

    const showOutperformsActiveNavItem = (isMoveUpAction) => {
      const outperformsNavActiveItem = document.querySelector(
        '.outperforms-nav-item.active'
      );
      const index = getActiveElementIndex(outperformsNavActiveItem);
      const activeItemIndex = isMoveUpAction ? index - 1 : index + 1;
      const activeItem = outperformsListItems[activeItemIndex];

      if (activeItem) {
        toggleActiveListItems(
          activeItem,
          outperformsListItems,
          outperformsListItemsContent
        );

        scrollToTheCenterOfTheList(activeItem);
      }
    };

    const moveSlideUp = () => {
      showOutperformsActiveNavItem(true);
    };

    const moveSlideDown = () => {
      showOutperformsActiveNavItem(false);
    };

    outperformsArrowUp.addEventListener('click', moveSlideUp);
    outperformsArrowPrev.addEventListener('click', moveSlideUp);
    outperformsArrowDown.addEventListener('click', moveSlideDown);
    outperformsArrowNext.addEventListener('click', moveSlideDown);

    // Hootsuite Hub Page - Rating section - Charts
    const hootsuiteRatingSection = document.querySelector('.hootsuite-rating');
    const greyColor = '#C4C4C4';
    const pinkColor = '#fb89c0';
    const orangeColor = '#FF5500';
    const violetColor = '#7A66F0';
    const cutout = '80%';
    const spacing = 2;

    if (hootsuiteRatingSection) {
      const commonChartOptions = [greyColor, cutout, spacing];
      let pricingChart = generateChart(
        'hootsuite-rating-pricing-chart',
        violetColor,
        ...commonChartOptions
      );
      let reviewChart = generateChart(
        'hootsuite-rating-review-chart',
        pinkColor,
        ...commonChartOptions
      );
      let competitorsChart = generateChart(
        'hootsuite-rating-competitors-chart',
        orangeColor,
        ...commonChartOptions
      );

      const destroyCharts = () => {
        pricingChart.destroy();
        reviewChart.destroy();
        competitorsChart.destroy();
      };

      // Rating section
      const ratingListItems = document.querySelectorAll(
        '.hootsuite-rating-nav-item'
      );
      const ratingListItemsContent = document.querySelectorAll(
        '.hootsuite-rating-content-item'
      );

      const animateContentItems = () => {
        const reasonsListItemsDescriptions = document.querySelectorAll(
          '.hootsuite-rating-content-item-text'
        );
        const reasonsListItemsBoxes = document.querySelectorAll(
          '.hootsuite-rating-content-item-box'
        );

        reasonsListItemsDescriptions.forEach((item) => {
          recreateElement(item);
        });

        reasonsListItemsBoxes.forEach((item) => {
          recreateElement(item);
        });
      };

      addOnClickOnAllItems(ratingListItems, (e) => {
        toggleActiveListItems(
          e.target,
          ratingListItems,
          ratingListItemsContent
        );
        animateContentItems();
        destroyCharts();
        pricingChart = generateChart(
          'hootsuite-rating-pricing-chart',
          violetColor,
          ...commonChartOptions
        );
        reviewChart = generateChart(
          'hootsuite-rating-review-chart',
          pinkColor,
          ...commonChartOptions
        );
        competitorsChart = generateChart(
          'hootsuite-rating-competitors-chart',
          orangeColor,
          ...commonChartOptions
        );
      });
    }

    // Hootsuite Hub - Testimonials Read More Btn
    const readMoreLessBtns = document.querySelectorAll('.testimonial-text-btn');

    const showHideText = (e) => {
      const btn = e.target;
      const longText = btn.parentNode.querySelector('.long');
      const readMoreEn = 'Read More';
      const readLessEn = 'Read Less';
      const readMoreFr = 'Lire la suite';
      const readLessFr = 'Lire moins';
      const readMoreDe = 'Mehr anzeigen';
      const readLessDe = 'Weniger anzeigen';

      const addReadMoreBtnStyles = (btnText) => {
        btn.textContent = btnText;
        longText.style.opacity = '0';
        longText.style.height = '0';
        longText.style.width = '0';
        longText.style.position = 'absolute';
      };

      const addReadLessBtnStyles = (btnText) => {
        btn.textContent = btnText;
        longText.style.opacity = '1';
        longText.style.height = '100%';
        longText.style.width = '100%';
        longText.style.position = 'static';
      };

      if (window.location.pathname.includes('/fr/')) {
        if (btn.textContent.trim() === readMoreFr) {
          addReadLessBtnStyles(readLessFr);
        } else {
          addReadMoreBtnStyles(readMoreFr);
        }
      } else if (window.location.pathname.includes('/de/')) {
        if (btn.textContent.trim() === readMoreDe) {
          addReadLessBtnStyles(readLessDe);
        } else {
          addReadMoreBtnStyles(readMoreDe);
        }
      } else {
        if (btn.textContent.trim() === readMoreEn) {
          addReadLessBtnStyles(readLessEn);
        } else {
          addReadMoreBtnStyles(readMoreEn);
        }
      }
    };

    readMoreLessBtns.forEach((btn) => {
      btn.addEventListener('click', showHideText);
    });

    // Hootsuite Hub - Testimonials slider
    const testimonialsSlider = document.querySelector('.testimonials-slider');
    if (testimonialsSlider) {
      let testimonialsSlider;
      if (window.screen.width > 1200) {
        testimonialsSlider = new Siema({
          perPage: 3.5,
          selector: '.testimonials-slider',
          loop: false,
          draggable: true
        });
      } else if (window.screen.width > 991 && window.screen.width < 1200) {
        testimonialsSlider = new Siema({
          perPage: 2.5,
          selector: '.testimonials-slider',
          loop: false,
          draggable: true
        });
      } else {
        testimonialsSlider = new Siema({
          perPage: 1.5,
          selector: '.testimonials-slider',
          loop: false,
          draggable: true
        });
      }

      const prev = document.querySelector(
        '.hootsuite-testimonials-arrows-prev'
      );
      const next = document.querySelector(
        '.hootsuite-testimonials-arrows-next'
      );

      prev.addEventListener('click', () => testimonialsSlider.next());
      next.addEventListener('click', () => testimonialsSlider.prev());
    }

    // Hootsuite Hub - Videos section
    const videosSliderSection = document.querySelector('.hootsuite-videos');
    if (videosSliderSection) {
      const controlsContainer = document.querySelector(
        '.hootsuite-videos-nav-arrows'
      );

      const itemsCount = window.screen.width > 1200 ? 3 : 1;

      var slider = tns({
        container: '.hootsuite-videos',
        items: itemsCount,
        mouseDrag: true,
        controls: true,
        nav: false,
        loop: false,
        controlsContainer
      });

      // const resizeAllSlides = (allSlideItems, currentSlide) => {
      //   for (const item of allSlideItems) {
      //     item.style.opacity = '.6';
      //     item.style.transform = 'scale(.6)';
      //   }

      //   currentSlide.style.opacity = '1';
      //   currentSlide.style.transform = 'scale(1)';
      // };

      // const sliderInfo = slider.getInfo();
      // resizeAllSlides(
      //   sliderInfo.slideItems,
      //   sliderInfo.slideItems[sliderInfo.index]
      // );

      slider.events.on('indexChanged', (e) => {
        const allSlideItems = e.slideItems;
        const currentSlide = allSlideItems[e.index];

        // resizeAllSlides(allSlideItems, currentSlide);
      });
    }
  }
});
